// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/alert_count_stat.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { RiskLevel } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/alert_count_stat.proto.
 */
export const file_inventory_v1_alert_count_stat: GenFile = /*@__PURE__*/
  fileDesc("CiNpbnZlbnRvcnkvdjEvYWxlcnRfY291bnRfc3RhdC5wcm90bxIMaW52ZW50b3J5LnYxIkwKDkFsZXJ0Q291bnRTdGF0EisKCnJpc2tfbGV2ZWwYASABKA4yFy5pbnZlbnRvcnkudjEuUmlza0xldmVsEg0KBWNvdW50GAIgASgFQrsBChBjb20uaW52ZW50b3J5LnYxQhNBbGVydENvdW50U3RhdFByb3RvUAFaQWdpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vaW52ZW50b3J5L3YxO2ludmVudG9yeXYxogIDSVhYqgIMSW52ZW50b3J5LlYxygIMSW52ZW50b3J5XFYx4gIYSW52ZW50b3J5XFYxXEdQQk1ldGFkYXRh6gINSW52ZW50b3J5OjpWMWIGcHJvdG8z", [file_inventory_v1_risk]);

/**
 * @generated from message inventory.v1.AlertCountStat
 */
export type AlertCountStat = Message<"inventory.v1.AlertCountStat"> & {
  /**
   * @generated from field: inventory.v1.RiskLevel risk_level = 1;
   */
  riskLevel: RiskLevel;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message inventory.v1.AlertCountStat.
 * Use `create(AlertCountStatSchema)` to create a new message.
 */
export const AlertCountStatSchema: GenMessage<AlertCountStat> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_count_stat, 0);

